import { render, staticRenderFns } from "./HistoryGame.vue?vue&type=template&id=4ec23322&scoped=true"
import script from "./HistoryGame.vue?vue&type=script&lang=js"
export * from "./HistoryGame.vue?vue&type=script&lang=js"
import style0 from "./HistoryGame.vue?vue&type=style&index=0&id=4ec23322&prod&scoped=true&lang=css"
import style1 from "./HistoryGame.vue?vue&type=style&index=1&id=4ec23322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec23322",
  null
  
)

export default component.exports